import { MobXProviderContext } from 'mobx-react'
import React from "react";
export default function useMyStores() {
    return React.useContext(MobXProviderContext)
}
